import { MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import SoloIcon from "../SoloIcon";
import MetricBarChart from "../charts/MetricBarChart";
import { useDashboardColor } from "../../context/DashboardColorContext";
import GradientBar from "../GradientBar";
import MetricStatValue from "../charts/MetricStatValue";

const ChildFamilyMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag }: MetricPanelProps) => { 
    const color = useDashboardColor();
      
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("Child & Family data:", sortedMetrics);

    // Separate metrics with IDs 1100 and 1102 into an array
    const child = sortedMetrics[0];
    const singleMothers = indicators.find((i: any) => i.id === 1108);
    const singleFathers = indicators.find((i: any) => i.id === 1109);
    const singleParents = indicators.find((i: any) => i.id === 1106);
    const childByAge = indicators.find((i: any) => i.id === 1078);

    return (
        <div className="h-screen">
        <p className="text-xs text-neutral-600 mx-6 pt-2">
            Activate the <span aria-hidden="true">🛈</span> <strong>button</strong> to expand additional information about a metric.
        </p>
        <div className="mx-auto px-4 pb-8 pt-2">
            <div className="grid grid-cols-1 xxs:grid-cols-2 gap-4">
                {child.map((metric: any) => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        svg={getSvgrMap(metric.id)} 
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                    />
                ))}
        
                <div className="col-span-1 xxs:col-span-2 w-full">
                    <div 
                        className="relative overflow-hidden group hover:shadow-md transition-all border rounded-xl bg-white" 
                    >
                        <div className="bg-white p-3">
                            <h3 className="text-sm font-semibold text-color-cai-brown">
                                Single Parent Families
                            </h3>
                            
                            <div className="grid grid-cols-3 gap-4">
                                <div className="flex flex-col items-center">
                                    <div className="ml-20">
                                        <SoloIcon
                                            key={1108}
                                            id={1108}
                                            unit={singleMothers?.versions[0].unit}
                                            title={singleMothers?.name ?? "Single Mother Families"}
                                            svg={undefined}
                                            disaggData={indicators}
                                            geoDetails={geoDetails}
                                            geoTag={geoTag}
                                        />
                                    </div>
                                    <MetricStatValue metric={singleMothers}/>
                                </div>
                                <div className="flex flex-col items-center">
                                    <div className="ml-20">
                                        <SoloIcon
                                            key={1109}
                                            id={1109}
                                            unit={singleFathers?.versions[0].unit}
                                            title={singleFathers?.name ?? "Single Father Families"}
                                            svg={undefined}
                                            disaggData={indicators}
                                            geoDetails={geoDetails}
                                            geoTag={geoTag}
                                        />
                                    </div>
                                    <MetricStatValue metric={singleFathers}/>
                                </div>
                                <div className="flex flex-col items-center">
                                    <div className="ml-20">
                                        <SoloIcon
                                            key={1106}
                                            id={1106}
                                            unit={singleParents?.versions[0].unit}
                                            title={singleParents?.name ?? "Single Parent Families"}
                                            svg={undefined}
                                            disaggData={indicators}
                                            geoDetails={geoDetails}
                                            geoTag={geoTag}
                                        />
                                    </div>
                                    <MetricStatValue metric={singleParents}/>
                                </div>
                            </div>
                        </div>
                        <GradientBar color={color} />
                    </div>
                </div>

                <div className="col-span-1 xxs:col-span-2 w-full">
                    {childByAge && 
                        <MetricBarChart 
                            metric={childByAge}
                            svg={null}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            height="h-40" 
                            background="bg-white"
                            barColor="#1a3a67"
                        />
                    }
                </div>
            </div>
        </div>
        </div>
    );
}

export default ChildFamilyMetrics;